import React from 'react'
import HeaderInner from '../header/HeaderInner';
import BreadcrumbBlog from '../inner//breadcrumb/BreadcrumbBlog';
import Footer from '../elements/Footer';
import { Link } from 'react-router-dom';




function BlogColTwo() {
  return (
    <div className='service-details'>
        <div className="">
            <HeaderInner/>
            <main>
                <BreadcrumbBlog/>
                {/* tmp service section */}
                <div className="tmp-service-section tmp-section-gap">
                    <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                        <div className="blog-details-wrapper-v2">
                            <div className="thumbnail-top ">
                            <img
                                src="assets/images/blog/details/01.png"
                                alt="Corporate_business"
                            />
                            </div>
                        </div>
                        </div>
                        <div className="col-lg-8 offset-lg-2 mt--40">
                        <div className="blog-details-left-area border-bottom">
                            <h2 className="title split-collab mb--10 text-start">
                            How to Choose the Perfect Corporate Business Template for Your
                            Company
                            </h2>
                            <div className="blog-details-discription">
                            <div className="category-area">Sultan Ahmed / Consulting</div>
                            <p className="disc">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                                nulla pariatur.Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit. Curabitur eget ornare quam. Sed sit amet sem
                                sollicitudin.
                            </p>
                            <p className="disc">
                                Ut enim ad minim veniam, quis nostrud exercitation ullamco
                                laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure
                                dolor in reprehenderit in voluptate velit esse cillum dolore eu
                                fugiat nulla pariatur.Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit. Curabitur eget ornare quam. Sed sit amet sem
                                sollicitudin, condiment diam sed.
                            </p>
                            </div>
                            <div className="quote-area-blog-details">
                            <i className="fa-sharp fa-regular fa-quote-left fa-lg" />
                            <p className="disc">
                                Rockling Devario deep sea bonefish cutthroat trout streamer fish
                                kaluga sailback scorpionfish sand dab, turkeyfish golden loach
                                sand diver. Leopard danio píntano bonnet mouth.
                            </p>
                            <span className="author">David Miller</span>
                            </div>
                            <div className="blog-details-discription">
                            <p className="disc">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                                nulla pariatur.Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit. Curabitur eget ornare quam. Sed sit amet sem
                                sollicitudin.
                            </p>
                            <div className="short-feature-blog-details">
                                <div className="single-feature">
                                How will digital activities impact traditional manufacturing.
                                </div>
                                <div className="single-feature">
                                I monitor my staff with software that takes screen.
                                </div>
                                <div className="single-feature">
                                Minim veniam quis niacin sodium nostrud exer.
                                </div>
                                <div className="single-feature">
                                Laoreet dolore magna niacin sodium glutimate.
                                </div>
                                <div className="single-feature">
                                Narrow formal length my highly
                                </div>
                            </div>
                            <p className="disc">
                                Ut enim ad minim veniam, quis nostrud exercitation ullamco
                                laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure
                                dolor in reprehenderit in voluptate velit esse cillum dolore eu
                                fugiat nulla pariatur.Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit. Curabitur eget ornare quam. Sed sit amet sem
                                sollicitudin, condiment diam sed.
                            </p>
                            <p className="disc">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                                nulla pariatur.Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit. Curabitur eget ornare quam. Sed sit amet sem
                                sollicitudin.
                            </p>
                            <p className="disc">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                                nulla pariatur.Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit. Curabitur eget ornare quam. Sed sit amet sem
                                sollicitudin.
                            </p>
                            </div>
                            <div className="row g-5">
                            <div className="col-lg-6">
                                <div className="thumbnail-50">
                                <img src="assets/images/blog/details/02.jpg" alt="" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="thumbnail-50">
                                <img src="assets/images/blog/details/03.jpg" alt="" />
                                </div>
                            </div>
                            </div>
                            <div className="blog-details-discription">
                            <p className="disc">
                                Ut enim ad minim veniam, quis nostrud exercitation ullamco
                                laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure
                                dolor in reprehenderit in voluptate velit esse cillum dolore eu
                                fugiat nulla pariatur.Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit. Curabitur eget ornare quam. Sed sit amet sem
                                sollicitudin, condiment diam sed.
                            </p>
                            <p className="disc">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                                nulla pariatur.Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit. Curabitur eget ornare quam. Sed sit amet sem
                                sollicitudin.
                            </p>
                            </div>
                        </div>
                        <div className="blog-details-bottom-area mt--40">
                            <div className="tag-socila-area-blgo-details">
                            <div className="left-tag">
                                <span>Tag:</span>
                                <div className="tag-wrapper">
                                <div className="signle-wrapper">Algoritham</div>
                                <div className="signle-wrapper">Data Science</div>
                                </div>
                            </div>
                            <div className="social-blog-tag-area">
                                <span>Search:</span>
                                <ul>
                                <li>
                                    <Link to={'#'}>
                                    <i className="fa-brands fa-facebook-f" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={'#'}>
                                    <i className="fa-brands fa-twitter" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={'#'}>
                                    <i className="fa-brands fa-pinterest-p" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={'#'}>
                                    <i className="fa-brands fa-linkedin-in" />
                                    </Link>
                                </li>
                                </ul>
                            </div>
                            </div>
                            <div className="author-comment-area">
                            <div className="thumbnail">
                                <img
                                src="assets/images/blog/details/04.jpg"
                                alt="Corporate_Business"
                                />
                            </div>
                            <div className="main-information-of-autonr">
                                <h6 className="name">Md Jonny</h6>
                                <p className="disc">
                                Lorem ipsum dolor sit amet consectetur adipiscing elit sed do
                                eiusmod tempor sed ut perspiciatis unde omnis iste natus error
                                sit voluptatem accusantium.
                                </p>
                                <div className="social-blog-tag-area">
                                <ul>
                                    <li>
                                    <Link to={'#'}>
                                        <i className="fa-brands fa-facebook-f" />
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to={'#'}>
                                        <i className="fa-brands fa-twitter" />
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to={'#'}>
                                        <i className="fa-brands fa-pinterest-p" />
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to={'#'}>
                                        <i className="fa-brands fa-linkedin-in" />
                                    </Link>
                                    </li>
                                </ul>
                                </div>
                            </div>
                            </div>
                            <div className="comment-area-main-wrapper mt--30">
                            <h3 className="title">Comments (3)</h3>
                            <div className="single-comment-audience border-bottom pb--30">
                                <div className="author-image">
                                <img
                                    src="assets/images/blog/details/05.png"
                                    alt="Corporate_business"
                                />
                                </div>
                                <div className="right-area-commnet">
                                <div className="top-area-comment">
                                    <div className="left">
                                    <h6 className="title">James Smith</h6>
                                    <span>March 20, 2024</span>
                                    </div>
                                    <button>
                                    <i className="fa-solid fa-share fa-flip-both fa-lg" />
                                    Reply
                                    </button>
                                </div>
                                <p className="disc mt--15">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                    do eiusmod tempor incididunt ut labore et dolore magna
                                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                                    Duis aute irure dolor in reprehenderit in voluptate .
                                </p>
                                </div>
                            </div>
                            <div className="single-comment-audience border-bottom pb--30 pl--50 pl_sm--0">
                                <div className="author-image">
                                <img
                                    src="assets/images/blog/details/06.png"
                                    alt="Corporate_business"
                                />
                                </div>
                                <div className="right-area-commnet">
                                <div className="top-area-comment">
                                    <div className="left">
                                    <h6 className="title">Adom Smith</h6>
                                    <span>February 20, 2024</span>
                                    </div>
                                    <button>
                                    <i className="fa-solid fa-share fa-flip-both fa-lg" />
                                    Reply
                                    </button>
                                </div>
                                <p className="disc mt--15">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                    do eiusmod tempor incididunt ut labore et dolore magna
                                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                                    Duis aute irure.
                                </p>
                                </div>
                            </div>
                            <div className="single-comment-audience">
                                <div className="author-image">
                                <img
                                    src="assets/images/blog/details/07.png"
                                    alt="Corporate_business"
                                />
                                </div>
                                <div className="right-area-commnet">
                                <div className="top-area-comment">
                                    <div className="left">
                                    <h6 className="title">Mr Lee Smith</h6>
                                    <span>February 28, 2023</span>
                                    </div>
                                    <button>
                                    <i className="fa-solid fa-share fa-flip-both fa-lg" />
                                    Reply
                                    </button>
                                </div>
                                <p className="disc mt--15">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                    do eiusmod tempor incididunt ut labore et dolore magna
                                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                                    Duis aute irure dolor in reprehenderit in voluptate .
                                </p>
                                </div>
                            </div>
                            </div>
                            <div className="blog-details-form-wrapper">
                            <h4 className="title">Leave A Comments</h4>
                            <span>
                                Your email address will not be published. Required fields are
                                marked *
                            </span>
                            <form action="#" className="blog-details-form">
                                <div className="single-input">
                                <input type="text" placeholder="Name" />
                                <i className="fa-light fa-user" />
                                </div>
                                <div className="half-input-wrapper">
                                <div className="single-input">
                                    <input type="text" placeholder="Email" />
                                    <i className="fa-light fa-envelope" />
                                </div>
                                <div className="single-input">
                                    <input type="text" placeholder="Website" />
                                    <i className="fa-light fa-globe" />
                                </div>
                                </div>
                                <textarea placeholder="Write a Message" defaultValue={""} />
                                <button className="tmp-btn btn-primary">Submit Comment</button>
                            </form>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                {/* tmp service section end */}
                <Footer/>
            </main>
        </div>
    </div>
  )
}

export default BlogColTwo